import { ExpressionConfiguration } from "../../rule-engine-core/Expressions/ExpressionConfiguration";
import { ExpressionBuilder } from "../ExpressionBuilder";
import { StringIndexOfExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringIndexOfExpression";
import { StringListInExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListInExpression";
import { StringListContainsExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListContainsExpression";
import { StringStartWithExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringStartWithExpression";
import { StringTrimExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringTrimExpression";
import { StringUppercaseExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringUppercaseExpression";
import { StringLowercaseExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringLowercaseExpression";
import { StringNotContainsExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringNotContainsExpression";
import { StringListNotContainsExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListNotContainsExpression";
import { StringListNotAllInExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListNotAllInExpression";
import { StringListAllInExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListAllInExpression";
import { StringProperExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringProperExpression";
import { StringLengthExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringLengthExpression";
import { StringCombineExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringCombineExpression";
import { StringListNotInExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListNotInExpression";
import { StringContainsExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringContainsExpression";
import { StringEndWithExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringEndWithExpression";
import { StringListGetStringByIndexExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListGetStringByIndexExpression";
import { StringIsNotEmptyExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringIsNotEmptyExpression";
import { StringListCombineExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringListCombineExpression";
import { StringIsEmptyExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringIsEmptyExpression";
import { StringIsValidEmailExpression } from "../../rule-engine-core/Expressions/Expressions/String/StringIsValidEmailExpression";
import { StoryNode } from "../../CommonUI/StoryBook/StoryData";
import type { AppGlueAny } from "../../rule-engine-core/Common/AppGlueAny";

let expression: AppGlueAny;
let exp: AppGlueAny;

export const ExpressionStringStories = [
    new StoryNode(
        () => {
            expression = new StringListCombineExpression();
            expression.value1.valueName = "stringList";
            expression.value2.value = ["1", "2"];
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "List Combine",
    ),
    new StoryNode(
        () => {
            expression = new StringCombineExpression();
            expression.value1.value = "a";
            expression.value2.value = "b";
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Combine",
    ),
    new StoryNode(
        () => {
            expression = new StringContainsExpression();
            expression.value1.value = "ab";
            expression.value2.value = "b";
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "String Contains",
    ),
    new StoryNode(
        () => {
            expression = new StringEndWithExpression();
            expression.value1.value = "ab";
            expression.value2.value = "b";
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "End With",
    ),
    new StoryNode(
        () => {
            expression = new StringIndexOfExpression();
            expression.value1.value = "ab";
            expression.value2.value = "b";
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Index Of",
    ),
    new StoryNode(
        () => {
            expression = new StringIsEmptyExpression();
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Is Empty",
    ),
    new StoryNode(
        () => {
            expression = new StringIsNotEmptyExpression();
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Is Not Empty",
    ),
    new StoryNode(
        () => {
            expression = new StringIsValidEmailExpression();
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Is Valid Email",
    ),
    new StoryNode(
        () => {
            expression = new StringLengthExpression();
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Length",
    ),
    new StoryNode(
        () => {
            expression = new StringListAllInExpression();
            expression.value1.value = ["1", "2"];
            expression.value2.value = ["3", "4"];
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "List All In",
    ),
    new StoryNode(
        () => {
            expression = new StringListContainsExpression();
            expression.value1.value = ["1", "2"];
            expression.value2.value = "1";
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "List Contains",
    ),
    new StoryNode(
        () => {
            expression = new StringListGetStringByIndexExpression();
            expression.value1.value = 2;
            expression.value2.variableName = "stringList";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "String By Index",
    ),
    new StoryNode(
        () => {
            expression = new StringListInExpression();
            expression.value1.value = "aaa";
            expression.value2.variableName = "stringList";
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "List In",
    ),
    new StoryNode(
        () => {
            expression = new StringListNotAllInExpression();
            expression.value1.value = ["aaa", "bbb"];
            expression.value2.variableName = "stringList";
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "List Not All In",
    ),
    new StoryNode(
        () => {
            expression = new StringListNotContainsExpression();
            expression.value1.value = ["aaa", "bbb"];
            expression.value2.variableName = "stringList";
            exp = new ExpressionConfiguration();
            exp.expression = expression;

            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "List Not Contains",
    ),
    new StoryNode(
        () => {
            expression = new StringListNotInExpression();
            expression.value1.variableName = "stringList";
            expression.value2.value = ["aaa", "bbb"];
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "List Not In",
    ),
    new StoryNode(
        () => {
            expression = new StringLowercaseExpression();
            expression.value1.variableName = "stringVal";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Lower Case",
    ),

    new StoryNode(
        () => {
            expression = new StringNotContainsExpression();
            expression.value1.variableName = "stringVal";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Not Contains",
    ),
    new StoryNode(
        () => {
            expression = new StringProperExpression();
            expression.value1.variableName = "stringVal";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Proper Case",
    ),
    new StoryNode(
        () => {
            expression = new StringStartWithExpression();
            expression.value1.variableName = "stringVal";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Starts With",
    ),
    new StoryNode(
        () => {
            expression = new StringTrimExpression();
            expression.value1.variableName = "stringVal";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Trim",
    ),
    new StoryNode(
        () => {
            expression = new StringUppercaseExpression();
            expression.value1.variableName = "stringVal";
            exp = new ExpressionConfiguration();
            exp.expression = expression;
            return <ExpressionBuilder expression={exp}></ExpressionBuilder>;
        },

        "Expression Builder",
        "String",
        "Upper Case",
    ),
];
